import React from "react";
import ReactDOM from "react-dom";
import "./index.scss";
import App from "./App";
import UserConfigContextProvider from "./model/UserConfigContext";


ReactDOM.render(
    <React.StrictMode>
        <UserConfigContextProvider>
            <App/>
        </UserConfigContextProvider>
    </React.StrictMode>,
    document.getElementById('root')
);